import React from 'react';
import CompanyLogin from '../pages/CompanyLogin';
import AuthLayout from '../layouts/AuthLayout';
import CompanyForgotPassword from '../pages/CompanyForgot';
import CompanyResetPassword from '../pages/ResetComapnyPassword';
const authRoutes = {
  path: '/auth',
  element: <AuthLayout />,
  children: [
    {
      path: 'company-login',
      element: <CompanyLogin />
    },
    {
      path: 'company-login/company-forgot-password',
      element: <CompanyForgotPassword />
    },
    {
      path: 'company-login/company-reset-password',
      element: <CompanyResetPassword />
    }
  ]
};

export default authRoutes;
